import 'react-app-polyfill/ie11'; // REQUIRED for IE11 polyfills
import 'react-app-polyfill/stable'; // REQUIRED for all other polyfills
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import { HttpErrorPage } from '@paycor/design-system';
import * as serviceWorker from './serviceWorker';
import App from './App';
import './index.scss';
import config from 'config';

// This will intercept any 401 responses from HTTP/XHR calls and redirect the user to the login screen. Additional
// response handlers can be defined, or the default 401 overwritten
// XHRInterceptor.createInterceptor(
// {
// 	403: () => {
// 		// your logic here
// 	}
// });

const container = document.getElementById('paycor-app-activation-ui');
const root = createRoot(container);
root.render(
	<Router basename={config.ENV_APP_NAME}>
		<HttpErrorPage>
			<App />
		</HttpErrorPage>
	</Router>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
